module.exports = __webpack_public_path__ + "static/media/search-plus.91317701.svg";